<template>
  <div style="height:100%;">
    <el-form :model="formData" :inline="true" size="mini"  ref="formData" label-width="100px" class="demo-ruleForm2">
      <div>
        <el-form-item label="用户名">
          <el-input :value="formData.userName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="应用系统名称">
          <el-input :value="formData.systemName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用户机构">
          <el-input :value="formData.depart" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="机构代码">
          <el-input :value="formData.depCode" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作IP">
          <el-input :value="formData.terminalId" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-input :value="formData.operateType ? formData.operateType : '后台'" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="模块名称">
          <el-input :value="formData.functionModule" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="详情">
          <el-input :value="formData.content" :disabled="true" type="textarea" :rows='4' resize="vertical"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>

export default {
  name: 'insertContent',
  props: {
    formData: {
      type: Object
    }
  },
  data() {
    return {

    };
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.demo-ruleForm2 {
  text-align: center;
  margin: 0 auto;
  height: 100%;

  .left {
    float: left;
  }
  .el-form-item {
    margin-top: 12px;
  }
  .el-input,
  .el-select,
  .el-cascader {
    width: 250px;
    height: 32px;

    input {
      height: 32px;
    }
  }

  .el-textarea {
    width: 250px;
  }
}
</style>
<style lang="scss">
.demo-ruleForm2 {
  .el-input.is-disabled .el-input__inner{
    color: #606266;
  }
  .el-textarea.is-disabled .el-textarea__inner{
    color: #606266;
  }
}
</style>
